module.exports = [
  // {
  //   label: "Home",
  //   subMenu: [
  //     { path: "/home-v1", label: "Home v1" },
  //     { path: "/home-v2", label: "Home v2" },
  //     { path: "/home-v3", label: "Home v3" },
  //     { path: "/home-v4", label: "Home v4" },
  //     { path: "/home-v5", label: "Home v5" },
  //     { path: "/home-v6", label: "Home v6" },
  //     { path: "/home-v7", label: "Home v7" },
  //     { path: "/home-v8", label: "Home v8" },
  //     { path: "/home-v9", label: "Home v9" },
  //     { path: "/home-v10", label: "Home v10" },
  //   ],
  // },
  // {
  //   label: "Listings",
  //   subMenu: [
  //     {
  //       label: "Grid View",
  //       subMenu: [
  //         { label: "Grid Default", path: "/grid-default" },
  //         { label: "Grid Full Width 3 Cols", path: "/grid-full-3-col" },
  //         { label: "Grid Full Width 4 Cols", path: "/grid-full-4-col" },
  //         { label: "Grid Full Width 2 Cols", path: "/grid-full-2-col" },
  //         {
  //           label: "Grid Full Width 1 Cols v1",
  //           path: "/grid-full-1-col-v1",
  //         },
  //         {
  //           label: "Grid Full Width 1 Cols v2",
  //           path: "/grid-full-1-col-v2",
  //         },
  //         { label: "Banner Search v1", path: "/banner-search-v1" },
  //         { title: "Banner Search v2", path: "/banner-search-v2" },
  //       ],
  //     },
  //     {
  //       label: "Map Style",
  //       subMenu: [
  //         {
  //           label: "Header Map Style",
  //           path: "/header-map-style",
  //         },
  //         { label: "Map V1", path: "/map-v1" },
  //         { label: "Map V2", path: "/map-v2" },
  //         { label: "Map V3", path: "/map-v3" },
  //         { label: "Map V4", path: "/map-v4" },
  //       ],
  //     },
  //     {
  //       label: "Listing View",
  //       subMenu: [
  //         { label: "List v1", path: "/list-v1" },
  //         { label: "List All Style", path: "/list-all-style" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   label: "Property",
  //   subMenu: [
  //     {
  //       label: "Agents",
  //       subMenu: [
  //         { label: "Agents", path: "/agents" },
  //         { label: "Agent Single", path: "/agent-single/1" },
  //         { label: "Agency", path: "/agency" },
  //         { label: "Agency Single", path: "/agency-single/1" },
  //       ],
  //     },

  //     {
  //       label: "Single Style",
  //       subMenu: [
  //         { label: "Single V1", path: "/single-v1/1" },
  //         { label: "Single V2", path: "/single-v2/1" },
  //         { label: "Single V3", path: "/single-v3/1" },
  //         { label: "Single V4", path: "/single-v4/1" },
  //         { label: "Single V5", path: "/single-v5/1" },
  //         { label: "Single V6", path: "/single-v6/1" },
  //         { label: "Single V7", path: "/single-v7/1" },
  //         { label: "Single V8", path: "/single-v8/1" },
  //         { label: "Single V9", path: "/single-v9/1" },
  //         { label: "Single V10", path: "/single-v10/1" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   label: "Dashboard",
  //   subMenu: [
  //     { label: "Dashboard Home", path: "/dashboard-home" },
  //     { label: "Message", path: "/dashboard-message" },
  //     { label: "New Property", path: "/dashboard-add-property" },
  //     { label: "My Properties", path: "/dashboard-my-properties" },
  //     { label: "My Favorites", path: "/dashboard-my-favourites" },
  //     { label: "Saved Search", path: "/dashboard-saved-search" },
  //     { label: "Reviews", path: "/dashboard-reviews" },
  //     { label: "My Package", path: "/dashboard-my-package" },
  //     { label: "My Profile", path: "/dashboard-my-profile" },
  //   ],
  // },
  // {
  //   label: "Blog",
  //   subMenu: [
  //     { path: "/blog-list-v1", label: "Blog List V1" },
  //     { path: "/blog-list-v2", label: "Blog List V2" },
  //     { path: "/blog-list-v3", label: "Blog List V3" },
  //     { path: "/blogs/2", label: "Blog Single" },
  //   ],
  // },

  // {
  //   label: "Pages",
  //   subMenu: [
  //     { path: "/about", label: "About" },
  //     { path: "/contact", label: "Contact" },
  //     { path: "/compare", label: "Compate" },
  //     { path: "/pricing", label: "Pricing" },
  //     { path: "/faq", label: "Faq" },
  //     { path: "/login", label: "Login" },
  //     { path: "/register", label: "Register" },
  //     { path: "/404", label: "404" },
  //     { path: "/invoice", label: "Invoice" },
  //   ],
  // },
  {
    label: "Features",
    path: "#",
    subMenu: [],
    section: 'features'
  },
  {
    label: "Platform Overview",
    path: "#",
    subMenu: [],
    section: 'platform-overview',
  },
//   {
//     label: "Use Cases",
//     path: "#",
//     subMenu: [],
//   },
//   {
//     label: "Screenshots",
//     path: "#",
//     subMenu: [],
//   },
];
